// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".background[data-v-fc8af768]{background-size:100% 100%}.pageTitleFixed[data-v-fc8af768]{position:fixed;top:0;left:0;width:100%;z-index:1;background-color:#fff;color:#333}.van-nav-bar[data-v-fc8af768]{background-color:transparent}[class*=van-hairline][data-v-fc8af768]:after{border:none}[data-v-fc8af768]:export{green:#1989fa;white:#fff}", ""]);
// Exports
module.exports = exports;
